export const SET_TAXES_LIST = "SET_TAXES_LIST";
export const SET_TAX_CATEGORIES_LIST = "SET_TAX_CATEGORIES_LIST";
